import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./componant/homePage/Home";
import Header from "./common/Header";
import PeopleHomePage from "./componant/people/PeopleHomePage";
// import BioDiversity from "./componant/detailPage/innerPage/Programmes/BioDiversity";
// import RestoringHope from "./componant/detailPage/innerPage/Programmes/RestoringHope";
import EmpoweringCommunities from "./componant/detailPage/innerPage/Programmes/EmpoweringCommunities";
// import DonateHomePage from "./componant/detailPage/donate/DonateHomePage";
// import CommunityAndResource from "./componant/detailPage/innerPage/Programmes/CommunityAndResource";
// import CommunityAndWelbeing from "./componant/detailPage/innerPage/Programmes/CommunityAndWelbeing";
// import SustainableFisheries from "./componant/detailPage/innerPage/Programmes/SustainableFisheries";
import Neera from "./componant/detailPage/innerPage/features/Neera";
import FoodWeb from "./componant/detailPage/innerPage/features/FoodWeb";
import ProfilePage from "./componant/detailPage/innerPage/ProfilePage";
import Editorial from "./componant/detailPage/innerPage/publication/Editorial";
import Book from "./componant/detailPage/innerPage/publication/Book";
import Documentary from "./componant/detailPage/innerPage/publication/Documentary";
import EducationOutreach from "./componant/detailPage/innerPage/publication/EducationOutreach";
import FieldGuide from "./componant/detailPage/innerPage/publication/FieldGuide";
import FutureCalendar from "./componant/detailPage/innerPage/publication/FutureCalendar";
import JournalArticle from "./componant/detailPage/innerPage/publication/JournalArticle";
import ModulesandGuide from "./componant/detailPage/innerPage/publication/ModulesandGuide";
import OpinionandCommentaries from "./componant/detailPage/innerPage/publication/OpinionandCommentaries";
import PopularArticle from "./componant/detailPage/innerPage/publication/PopularArticle";
import Report from "./componant/detailPage/innerPage/publication/Report";
import MaterialsCategory from "./componant/detailPage/innerPage/publication/MaterialsCategory";
import ArticlesCategory from "./componant/detailPage/innerPage/publication/ArticlesCategory";
import Project from "./componant/detailPage/innerPage/project/Project";
import FutureVoices from "./componant/detailPage/innerPage/features/FutureVoices";
import PublicSpeech from "./componant/detailPage/innerPage/features/PublicSpeech";
import YoungVoices from "./componant/detailPage/innerPage/features/YoungVoices";
import CartoonCompeition from "./componant/detailPage/innerPage/features/CartoonCompeition";
import HumourMeets from "./componant/detailPage/innerPage/features/HumourMeets";
import PaintingCompeition from "./componant/detailPage/innerPage/features/PaintingCompeition";
import ClimateCrisis from "./componant/detailPage/innerPage/features/ClimateCrisis";
import ReefLeads from "./componant/detailPage/innerPage/features/ReefLeads";
import OceanStruggles from "./componant/detailPage/innerPage/features/OceanStruggles";
import GalleryHomePage from "./componant/gallery/GalleryHomePage";
import GalleryDetailPage from "./componant/gallery/GalleryDetailPage";
import RisingSea from "./componant/detailPage/innerPage/features/RisingSea";
import FeaturesPage from "./componant/detailPage/innerPage/features/FeaturesPage";
import Login from "./authentication/login/Login";
import ProtectedRoute from "./page-restriction/ProtectedRoute";
import Dashboard from "./dashboard/pages/DashBoard";
import EmployeesManager from "./dashboard/pages/employeeManager/EmployeesManager";
import AddUser from "./dashboard/pages/employeeManager/AddUser";
import FreshLeads from "./dashboard/pages/leadManager/FreshLeads";
import FakeLeads from "./dashboard/pages/leadManager/FakeLeads";
import FollowUpLeads from "./dashboard/pages/leadManager/FollowUpLeads";
import ConvertedLeads from "./dashboard/pages/leadManager/ConvertedLeads";
import GeneratedLeads from "./dashboard/pages/leadManager/GeneratedLeads";
import AddBlog from "./dashboard/pages/blog/AddBlog";
import BlogList from "./dashboard/pages/blog/BlogList";
import ViewBlog from "./dashboard/pages/blog/ViewBlog";
import EditBlog from "./dashboard/pages/blog/EditBlog";
import BlogApproveList from "./dashboard/pages/blogApproval/BlogApproveList";
import ApprovedBlog from "./dashboard/pages/blogApproval/ApprovedBlog";
import ViewBlogApprovedList from "./dashboard/pages/blogApproval/ViewBlogApprovedList";
import AddNewPage from "./dashboard/pages/universityManager/AddNewPage";
import ViewPage from "./dashboard/pages/universityManager/ViewPage";
import EditPage from "./dashboard/pages/universityManager/EditPage";
import PageList from "./dashboard/pages/universityManager/PageList";
import AddSite from "./dashboard/pages/seoManager/AddSite";
import StaticPages from "./dashboard/pages/seoManager/StaticPages";
import AddMetaData from "./dashboard/pages/seoManager/AddMeataData";
import Locations from "./dashboard/pages/universityManager/Locations";
import { CookiesProvider } from "react-cookie";
import store from "../src/global/redux/store";
import { Provider } from "react-redux";
import AddProgramme from "./dashboard/pages/programme/AddProgramme";
import ProgrammeList from "./dashboard/pages/programme/ProgrammeList";
import AddPublication from "./dashboard/pages/publication/AddPublication";
import PublicationList from "./dashboard/pages/publication/PublicationList";
import AddFeature from "./dashboard/pages/feature/AddFeature";
import FeatureList from "./dashboard/pages/feature/FeatureList";
import AddPeople from "./dashboard/pages/people/AddPeople";
import PeopleList from "./dashboard/pages/people/PeopleList";
import FeatureDetailPage from "./componant/detailPage/innerPage/features/FeatureDetailPage";
import ProgrammeDetailPage from "./componant/detailPage/innerPage/Programmes/ProgrammeDetailPage";
import BlogArticle from "./componant/BlogArticle";
import Blog from "./componant/Blog";
import EditProgramme from "./dashboard/pages/programme/EditProgramme";
import EditPublication from "./dashboard/pages/publication/EditPublication";
import EditFeature from "./dashboard/pages/feature/EditFeature";
import EditPeople from "./dashboard/pages/people/EditPeople";
import PublicationDetailPage from "./componant/detailPage/innerPage/publication/PublicationDetailPage";
import PeopleCategoryPage from "./componant/detailPage/innerPage/people/PeopleCategoryPage";
import ProfileDetailPage from "./componant/detailPage/innerPage/people/ProfileDetailPage";
import PracticeHome from "./componant/homePage/practice/PracticeHome";
import AddPhotos from "./dashboard/pages/photos/AddPhotos";
import PhotosList from "./dashboard/pages/photos/PhotosList";
import EditPhotos from "./dashboard/pages/photos/EditPhotos";
import AddFilm from "./dashboard/pages/films/AddFilm"; // NEW
import FilmList from "./dashboard/pages/films/FilmList"; // NEW
import AddArticle from "./dashboard/pages/publications/AddArticle";
import ArticleList from "./dashboard/pages/publications/ArticleList";
import AddPdf from "./dashboard/pages/publications/AddPdf";
import PdfList from "./dashboard/pages/publications/PdfList";
import EditFilm from "./dashboard/pages/films/EditFilm";

import { NavProvider } from "./context/NavContext";

function App() {
  return (
    <>
      <CookiesProvider>
        <Provider store={store}>
          <NavProvider>
            <Router>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/empowering-communities"
                  element={<EmpoweringCommunities />}
                />
                <Route
                  path="/programme/:ogUrl"
                  element={<ProgrammeDetailPage />}
                />
                <Route
                  path="/publication/:ogUrl"
                  element={<PublicationDetailPage />}
                />
                <Route
                  path="/publication/materials/:category"
                  element={<MaterialsCategory />}
                />
                <Route
                  path="/publication/materials/:category/:subcategory"
                  element={<MaterialsCategory />}
                />
                <Route
                  path="/publication/articles/:category"
                  element={<ArticlesCategory />}
                />
                <Route
                  path="/people/category/:ogUrl"
                  element={<PeopleCategoryPage />}
                />
                <Route path="/profile/:id" element={<ProfileDetailPage />} />
                <Route path="/neera-tapping" element={<Neera />} />
                <Route path="/feature/neera-tapping" element={<Neera />} />
                <Route path="/future-voices" element={<FutureVoices />} />
                <Route path="/feature/future-voices" element={<FutureVoices />} />
                <Route path="/public-speech" element={<PublicSpeech />} />
                <Route path="/feature/public-speech" element={<PublicSpeech />} />
                <Route
                  path="/cartoon-compeition"
                  element={<CartoonCompeition />}
                />
                <Route
                  path="/feature/cartoon-compeition"
                  element={<CartoonCompeition />}
                />
                <Route path="/humour-meets" element={<HumourMeets />} />
                <Route path="/feature/humour-meets" element={<HumourMeets />} />
                <Route path="/practice-home-page" element={<PracticeHome />} />
                <Route
                  path="/painting-compeition"
                  element={<PaintingCompeition />}
                />
                <Route
                  path="/feature/painting-compeition"
                  element={<PaintingCompeition />}
                />
                <Route path="/climate-crisis" element={<ClimateCrisis />} />
                <Route path="/feature/climate-crisis" element={<ClimateCrisis />} />
                <Route path="/ocean-struggles" element={<OceanStruggles />} />
                <Route path="/feature/ocean-struggles" element={<OceanStruggles />} />
                <Route path="/reef-leads" element={<ReefLeads />} />
                <Route path="/feature/reef-leads" element={<ReefLeads />} />
                <Route path="/young-voices" element={<YoungVoices />} />
                <Route path="/feature/young-voices" element={<YoungVoices />} />
                <Route path="/food-web" element={<FoodWeb />} />
                <Route path="/feature/food-web" element={<FoodWeb />} />
                <Route path="/rising-sea" element={<RisingSea />} />
                <Route path="/feature/rising-sea" element={<RisingSea />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route
                  path="/feature/:ogUrl"
                  element={<FeatureDetailPage />}
                />
                <Route path="/profile/:id" element={<ProfilePage />} />

                <Route path="/people-page" element={<PeopleHomePage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/photo/:id" element={<GalleryDetailPage />} />
                <Route path="/photo" element={<GalleryHomePage />} />
                <Route path="/project-members" element={<Project />} />
                <Route path="/blog/:ogUrl" exact element={<BlogArticle />} />

                {/* <Route path="/donate" element={<DonateHomePage />} /> */}

                <Route path="/book" element={<Book />} />
                <Route path="/documentary" element={<Documentary />} />
                <Route
                  path="/education-outreach"
                  element={<EducationOutreach />}
                />
                <Route path="/field-guide" element={<FieldGuide />} />
                <Route path="/future-calendar" element={<FutureCalendar />} />
                <Route path="/journal-article" element={<JournalArticle />} />
                <Route path="/modules-and-guide" element={<ModulesandGuide />} />
                <Route
                  path="/opinionand-commentaries"
                  element={<OpinionandCommentaries />}
                />
                <Route path="/popular-article" element={<PopularArticle />} />
                <Route path="/report" element={<Report />} />

                <Route path="/editorial" element={<Editorial />} />

                {/* admin dashboard */}
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/employee-manager/users"
                  exact
                  element={
                    <ProtectedRoute>
                      <EmployeesManager />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/employee-manager/add-user"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddUser />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/lead-manager/fresh-leads"
                  exact
                  element={
                    <ProtectedRoute>
                      <FreshLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/lead-manager/fake-leads"
                  exact
                  element={
                    <ProtectedRoute>
                      <FakeLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/lead-manager/follow-leads"
                  exact
                  element={
                    <ProtectedRoute>
                      <FollowUpLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/lead-manager/converted-leads"
                  exact
                  element={
                    <ProtectedRoute>
                      <ConvertedLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/lead-manager/generated-leads"
                  exact
                  element={
                    <ProtectedRoute>
                      <GeneratedLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-manager/add-blog"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddBlog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-manager/blog-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <BlogList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-manager/view-blog/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <ViewBlog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-manager/edit-blog/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditBlog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-approval/blog-approve-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <BlogApproveList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-approval/approved-blog-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <ApprovedBlog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-approval/approved-blog-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <ApprovedBlog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/blog-approval/view-blog-approve-list/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <ViewBlogApprovedList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/web-settings/locations"
                  exact
                  element={
                    <ProtectedRoute>
                      <Locations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/web-settings/add-new-page"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddNewPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings-manager/view-page/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <ViewPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings-manager/edit-page/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/web-settings/page-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <PageList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/seo-manager/add-sites"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/seo-manager/static-pages"
                  exact
                  element={
                    <ProtectedRoute>
                      <StaticPages />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
              path="/seo-manager/blog"
              exact
              element={
                <ProtectedRoute>
                  <DashBoardBlog />
                </ProtectedRoute>
              }
            /> */}
                <Route
                  path="/seo-manager/add-metadata/:site/:id"
                  element={
                    <ProtectedRoute>
                      <AddMetaData />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                path="/seo-manager/edit-metadata/:site/:id"
                element={
                  <ProtectedRoute>
                    <EditMetaData />
                  </ProtectedRoute>
                }
              /> */}
                <Route
                  path="/programme-manager/add-programme"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddProgramme />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/programme-manager/programme-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <ProgrammeList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/programme-manager/edit-programme/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditProgramme />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/add-article"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddArticle />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/article-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <ArticleList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/edit-article/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddArticle />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/add-pdf"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddPdf />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/pdf-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <PdfList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/publication-manager/edit-pdf/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddPdf />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/feature-manager/add-feature"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddFeature />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/feature-manager/feature-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <FeatureList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/feature-manager/edit-feature/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditFeature />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/people-manager/add-people"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddPeople />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/people-manager/people-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <PeopleList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/people-manager/edit-person/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditPeople />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/photos-manager/add-photos"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddPhotos />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/photos-manager/photos-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <PhotosList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/photo-manager/edit-photo/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditPhotos />
                    </ProtectedRoute>
                  }
                />
                {/* Films Module Routes */}
                <Route
                  path="/films-manager/add-film"
                  exact
                  element={
                    <ProtectedRoute>
                      <AddFilm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/films-manager/films-list"
                  exact
                  element={
                    <ProtectedRoute>
                      <FilmList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/films-manager/edit-film/:id"
                  exact
                  element={
                    <ProtectedRoute>
                      <EditFilm />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Router>
          </NavProvider >
        </Provider >
      </CookiesProvider >
    </>
  );
}

export default App;
